import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, PRECIO_LARGO } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 700;
      const target = document.getElementById('comprar');
      const nearOffer = target ? target.getBoundingClientRect().top < window.innerHeight : false;
      setVisible(past && !nearOffer);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-ink/10 bg-white/95 px-4 pb-[env(safe-area-inset-bottom)] backdrop-blur transition-transform duration-200 ease-out lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-169" data-mp="3gk5o9fnalwj4">
      <div className="flex items-center gap-3 py-3" data-id="element-170" data-mp="gyim89un8gqc">
        <div className="shrink-0" data-id="element-171" data-mp="75vrpc2b8n98">
          <p className="font-mono text-base font-bold leading-none text-ink" data-id="element-172" data-mp="76xfmh4fd48d">{PRECIO_LARGO}</p>
          <p className="mt-1 text-[11px] leading-none text-ink-muted" data-id="element-173" data-mp="27kjt6vksmtn">Acceso inmediato</p>
        </div>
        <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} className="flex-1 rounded-lg bg-naranja px-4 py-3.5 text-center font-display text-sm font-bold uppercase tracking-tight text-white transition-colors duration-150 ease-out hover:bg-naranja-dark" data-id="element-174" data-mp="gwqp9cl0b99z">
          Lo quiero ahora
        </a>
      </div>
    </div>;
}